<template>
  <div class="progress-bar">
    <div class="progress-bar-item" v-for="n in count" :key="n">
      <div
        :class="[
          'progress-bar-item-element',
          n > value ? 'progress-bar-item-disable' : '',
        ]"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: 'progressBar',
  props: {
    value: {
      type: Number,
      default: 0,
    },
    count: {
      type: Number,
      default: 5,
    },
  },
};
</script>

<style scoped>
.progress-bar {
  width: 100%;
  height: 6px;
  display: flex;
  flex-direction: row;
}

.progress-bar-item {
  height: 100%;
  flex: 1;
  background-color: #ffffff;
}

.progress-bar-item-element {
  margin: 0px 5px 0px 5px;
  background-color: #b18147;
  width: calc(100% - 10px);
  height: 100%;
}

.progress-bar-item-disable {
  background-color: #d8d8d8;
}
</style>
